import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slider.css';

import IconComponent from 'presentation/components/icon/icon';
import React from 'react';
import Slider from 'react-slick';

const SimpleSlider = ({ children }: React.PropsWithChildren<any>) => {
  const settings = {
    infinite: false,
    rows: 1,
    slidesToShow: 12.2,
    slidesToScroll: 4.2,
    nextArrow: <IconComponent name="arrowRight" />,
    prevArrow: <IconComponent name="arrowLeft" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 8.2,
          slidesToScroll: 6.2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 3,
          arrows: false,
        },
      },
    ],
  };
  return <Slider {...settings}>{children}</Slider>;
};

export default SimpleSlider;
